<template>
  <div class="text-expander-fi">
    <div
      :class="{
        'text-expander-fi__content': true,
        'text-expander-fi__content--expanded': isExpanded || !isExpandable,
        'text-expander-fi__content--expandable': isExpandable,
      }"
      :style="{
        gridTemplateRows: `${maxHeight}px ${isExpanded ? 1 : 0}fr`,
        maxHeight: isExpandable ? null : `${maxHeight}px`,
      }"
    >
      <div class="text-expander-fi__inner">
        <richtext-fi
          ref="expanderContent"
          :html-content="content"
        />
      </div>
    </div>

    <div
      v-if="isExpandable"
      class="text-expander-fi__expand"
    >
      <span
        class="text-expander-fi__expand-text"
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? reduceText : expandText }}
      </span>
    </div>
  </div>
</template>

<script>
import { RichtextFi } from 'atoms';

export default {
  name: 'TextExpanderFi',
  components: {
    RichtextFi,
  },
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    expandText: {
      type: String,
      default: 'expand',
    },
    reduceText: {
      type: String,
      default: 'reduce',
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      isExpandable: false,
      isExpanded: false,
      contentHeightExpanded: 0,
      contentStyles: null,
    };
  },
  mounted() {
    if (IS_SSR) {
      return;
    }
    if (this.$refs.expanderContent.$el.clientHeight > this.maxHeight) {
      this.isExpandable = true;
    }
  },
};
</script>

<style scoped src="./text-expander-fi" />
